interface CategoryItem {
  name: string;
  url: string;
  icon: string;
  imageUrl: string;
}

const categories: CategoryItem[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=White%20leather%20sneakers%20resting%20on%20sunlit%20wooden%20floorboards%2C%20rays%20of%20morning%20light%20streaming%20through%20window%20blinds%2C%20small%20potted%20succulent%20plant%20nearby%2C%20warm%20golden%20hour%20ambiance%2C%20lifestyle%20editorial%20photography%2C%20cozy%20modern%20apartment%20interior%2C%20soft%20natural%20shadows%2C%20relaxed%20Sunday%20morning%20atmosphere&width=600&height=450&seq=yoybuy-catg-01&orientation=landscape',
  },
  {
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Thick%20knitted%20cream%20colored%20sweater%20folded%20on%20vintage%20wooden%20chair%2C%20afternoon%20light%20creating%20warm%20shadows%20on%20textured%20wool%20fabric%2C%20hygge%20lifestyle%20scene%20with%20steaming%20mug%20of%20tea%20beside%20it%2C%20Scandinavian%20reading%20nook%20aesthetic%2C%20cozy%20winter%20fashion%20photography%2C%20soft%20focus%20background%20with%20bookshelf&width=600&height=450&seq=yoybuy-catg-02&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-air-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Organic%20cotton%20white%20t-shirt%20hanging%20on%20wooden%20clothes%20hanger%20outdoors%20on%20clothesline%2C%20gentle%20breeze%20visible%20in%20fabric%20movement%2C%20sunny%20garden%20background%20with%20green%20foliage%20softly%20blurred%2C%20natural%20lifestyle%20photography%2C%20fresh%20laundry%20aesthetic%2C%20bright%20summer%20day%2C%20eco-friendly%20sustainable%20fashion%20concept&width=600&height=450&seq=yoybuy-catg-03&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-vip-crown-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Olive%20green%20utility%20jacket%20draped%20over%20shoulder%20of%20person%20walking%20in%20autumn%20park%2C%20fallen%20leaves%20on%20ground%2C%20golden%20sunset%20backlight%20creating%20rim%20light%2C%20outdoor%20lifestyle%20photography%2C%20adventure%20ready%20aesthetic%2C%20warm%20earthy%20colors%2C%20candid%20moment%20captured%2C%20seasonal%20transition%20atmosphere&width=600&height=450&seq=yoybuy-catg-04&orientation=landscape',
  },
  {
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beige%20linen%20trousers%20artfully%20arranged%20on%20white%20sandy%20beach%20surface%2C%20ocean%20waves%20softly%20blurred%20in%20distance%2C%20seashells%20placed%20nearby%2C%20coastal%20lifestyle%20photography%2C%20resort%20wear%20aesthetic%2C%20bright%20natural%20sunlight%2C%20vacation%20mood%2C%20clean%20fresh%20composition%20with%20breezy%20summer%20feel&width=600&height=450&seq=yoybuy-catg-05&orientation=landscape',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-glasses-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Wide%20brim%20straw%20hat%20resting%20on%20colorful%20beach%20towel%20with%20sunglasses%20beside%20it%2C%20poolside%20setting%20with%20turquoise%20water%20softly%20blurred%20in%20background%2C%20summer%20vacation%20photography%2C%20resort%20lifestyle%20aesthetic%2C%20bright%20midday%20sunlight%2C%20tropical%20palm%20leaf%20shadow%20pattern%2C%20relaxed%20luxury%20atmosphere&width=600&height=450&seq=yoybuy-catg-06&orientation=landscape',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20athleisure%20matching%20set%20displayed%20on%20boutique%20clothing%20rack%2C%20warm%20boutique%20interior%20with%20exposed%20filament%20bulbs%2C%20fashion%20retail%20display%2C%20terrazzo%20floor%20visible%2C%20designer%20showroom%20aesthetic%2C%20soft%20ambient%20lighting%2C%20premium%20athleisure%20brand%20concept%2C%20curated%20color%20palette%20of%20sage%20green%20and%20cream&width=600&height=450&seq=yoybuy-catg-07&orientation=landscape',
  },
  {
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-shirt-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20cotton%20loungewear%20neatly%20folded%20in%20open%20suitcase%20on%20hotel%20bed%2C%20travel%20preparation%20scene%2C%20warm%20bedside%20lamp%20glow%2C%20boutique%20hotel%20room%20interior%20with%20velvet%20headboard%2C%20travel%20lifestyle%20photography%2C%20curated%20minimalist%20packing%20aesthetic%2C%20intimate%20evening%20atmosphere%2C%20ready%20for%20adventure&width=600&height=450&seq=yoybuy-catg-08&orientation=landscape',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-team-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Basketball%20jersey%20with%20bold%20number%20design%20hung%20on%20gym%20locker%20door%2C%20sports%20equipment%20bag%20on%20bench%20below%2C%20late%20afternoon%20gym%20lighting%20with%20long%20shadows%2C%20athletic%20facility%20interior%2C%20motivational%20sports%20photography%2C%20team%20spirit%20aesthetic%2C%20energetic%20atmosphere%20with%20motion%20blur%20effect&width=600&height=450&seq=yoybuy-catg-09&orientation=landscape',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-gift-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gold%20toned%20watch%20with%20leather%20band%20placed%20on%20open%20fashion%20magazine%20page%2C%20coffee%20table%20setting%20with%20ceramic%20vase%20of%20dried%20flowers%2C%20natural%20window%20light%20from%20left%2C%20editorial%20fashion%20photography%2C%20sophisticated%20lifestyle%20aesthetic%2C%20warm%20ambient%20tones%2C%20curated%20personal%20style%20concept%2C%20elegant%20Sunday%20morning&width=600&height=450&seq=yoybuy-catg-10&orientation=landscape',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-shopping-bag-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Craft%20leather%20backpack%20sitting%20on%20vintage%20railway%20station%20bench%2C%20travel%20journey%20concept%2C%20soft%20morning%20light%20filtering%20through%20station%20roof%2C%20nostalgic%20travel%20photography%2C%20adventure%20awaits%20aesthetic%2C%20worn%20wooden%20bench%20texture%2C%20subtle%20motion%20blur%20of%20passengers%20in%20background%2C%20timeless%20wanderlust%20atmosphere&width=600&height=450&seq=yoybuy-catg-11&orientation=landscape',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-archive-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Handcrafted%20leather%20belt%20hanging%20from%20brass%20hook%20on%20textured%20plaster%20wall%2C%20artisan%20workshop%20setting%20with%20leather%20crafting%20tools%20visible%20in%20soft%20focus%2C%20warm%20tungsten%20lighting%2C%20traditional%20craftsmanship%20aesthetic%2C%20rich%20cognac%20leather%20tones%2C%20workshop%20atmosphere%20with%20wood%20shavings%20on%20workbench%2C%20master%20artisan%20concept&width=600&height=450&seq=yoybuy-catg-12&orientation=landscape',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-contrast-drop-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crystal%20cut%20perfume%20bottle%20with%20amber%20liquid%20catching%20prismatic%20light%20on%20mirrored%20tray%2C%20luxury%20vanity%20setting%20with%20pearl%20necklace%20draped%20nearby%2C%20soft%20candlelight%20ambiance%2C%20boudoir%20aesthetic%2C%20warm%20golden%20reflections%2C%20sophisticated%20evening%20atmosphere%2C%20perfume%20boutique%20concept%2C%20elegant%20femininity&width=600&height=450&seq=yoybuy-catg-13&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Diverse%20collection%20of%20lifestyle%20products%20including%20notebook%20camera%20and%20ceramic%20mug%20arranged%20on%20reclaimed%20wood%20desk%2C%20creative%20workspace%20flatlay%2C%20morning%20sunlight%20casting%20long%20shadows%2C%20artist%20studio%20atmosphere%2C%20curated%20eclectic%20aesthetic%2C%20warm%20coffee%20tones%2C%20organized%20chaos%20concept%2C%20creative%20entrepreneur%20workspace&width=600&height=450&seq=yoybuy-catg-14&orientation=landscape',
  },
];

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 text-center mb-3">
          Все категории товаров
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-12 max-w-xl mx-auto">
          Выбирайте категорию и переходите к таблице заказов на Kaspreadsheet
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-100 rounded-2xl overflow-hidden hover:bg-background-200 transition-all cursor-pointer relative"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-3 md:p-4">
                <div className="flex items-center gap-2">
                  <span className="w-6 h-6 flex items-center justify-center text-accent-500">
                    <i className={`${cat.icon} text-sm`}></i>
                  </span>
                  <span className="text-sm font-medium text-foreground-800 group-hover:text-accent-600 transition-colors whitespace-nowrap truncate">
                    {cat.name}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}